<app-header></app-header>
<ng-container *ngIf = "contentToShow === 'home'">
<app-banner></app-banner>

<section class="pad-top-10 pad-bot-10 text-center show-card-text cfff" *ngIf="authenticated_user && userCardsText">
  <div class="main-line" *ngIf="GlobalConstants.client  != 'au-bank'">Showing <span class="f600" *ngIf = "pageType === 'special-benefits'">Special Benefits</span> <span *ngIf = "pageType === 'default'">benefits</span> on your <span class="f600"
       [innerHTML]="userCardsText"></span>. <span class="pointer" (click)="changeCurrentCard()"><u *ngIf = "multipleCards">Change card</u></span></div>
</section>
<section class="text-center pad-10 fnt-15 email-bar" *ngIf = "authenticated_user && emailVerified === 'false'">
  Please verify your email ID<b  *ngIf = "userEmail" [innerHtml] = "' '+userEmail"></b>. <span class="pointer underline f600 fnt-14" [ngStyle]="{'color': GlobalConstants.data.colors.active_text_color}" (click) = "verifyEmail()">Verify</span>
</section>
<section class="desktop bg-fff mar-bot-40" *ngIf="isDesktopDevice || isTablet">
  <section class="container category-contain mar-top-50" >
  <!-- Category -->
    <section class="flex w100 cat-overflow space-between">
      <!-- normal categories -->
      <ng-container *ngIf = "!isIslamic && offerCategories && offerCategories.length > 0">
      <div class="single-category pad-bot-15 pointer w100"
        *ngFor="let offerCategory of offerCategories.slice(0,GlobalConstants.data.desktop_category_count); let i = index"
        [ngStyle]="{'border-color':(offerBlockToShow == i || (offerBlockToShow == offerCategory.attributes.code)) ?  GlobalConstants.data.colors.active_text_color : 'transparent' }">
        <a routerLink="/offers/{{offerCategory.attributes.code}}" class="flex align-center justify-center d-c-icon">
          <img [src]="offerCategory?.attributes?.logo_url" class="img-fluid">
        </a>
        <div class=" d-c-title flex justify-center text-center fnt-14 uppercase c3A4149 relative">
          <a [ngStyle]="{'color':((offerBlockToShow == i) || (offerBlockToShow == offerCategory.attributes.code)) ?  GlobalConstants.data.colors.active_text_color : GlobalConstants.data.colors.main_text_color }"
            routerLink="/offers/{{offerCategory?.attributes?.code}}" class="pad-top-10">{{offerCategory.attributes.name}}</a>
          <div class="home-subcategory-dropdown pad-top-10" dropdown *ngIf="GlobalConstants.data.personalized_config.home_subcategory_dropdown &&
            offerCategory.attributes.sub_categories &&
            offerCategory.attributes.sub_categories.length > 0">
            <div dropdownToggle class="down-icon flex  align-center">
              <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L5 5L9 1" stroke="#333" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <div class="dropdown-menu subcat-drop dropdown-menu-shadow" *dropdownMenu>
              <div class="block loc-results">
                <ng-container>
                  <div class="fnt-14"
                    *ngFor="let subCategory of offerCategory.attributes?.sub_categories; let j = index">
                    <a class="option-box"
                      routerLink="/offers/{{offerCategory.attributes.code}}/{{subCategory.code}}">{{subCategory.name}}</a>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- More Block -->
      <div class="single-category pad-bot-15 pointer w100 indi-cat" style="border-color: transparent;"
        *ngIf="offerCategories && offerCategories.length > GlobalConstants.data.desktop_category_count">
        <div class="flex align-center pointer dropdown" dropdown>
          <div class="w100 h100 relative" dropdownToggle>
            <div class="flex align-center justify-center d-c-icon m-c-icon pad-top-2 relative">
              <img src="https://images.poshvine.com/logos/more.png" class="img-fluid">
            </div>
            <div class="flex justify-center text-center fnt-14 mar-top-4 c3A4149 relative f500">
              <span class="pad-top-10">More</span>
            </div>
          </div>
          <div class="dropdown-menu subcat-drop no-padding" *dropdownMenu>
            <div class="block loc-results">
              <div class="fnt-14" *ngFor="let category of offerCategories.slice(GlobalConstants.data.desktop_category_count); let j = index">

                <a class ="option-box pad-15 pad-top-5 pad-bot-5 pointer block c333" routerLink = "/offers/{{category.attributes.code}}">{{category.attributes.name}}</a>
              </div>

            </div>
          </div>

        </div>
      </div>
      </ng-container>
      <ng-container *ngIf = "isIslamic">
        <div class="single-category pad-bot-15 pointer w100" *ngFor = "let tab of tabsToShow; let i = index"
          [ngStyle]="{'border-color':(offerTypeToShow === tab.type) ?  GlobalConstants.data.colors.active_text_color : 'transparent' }"
          >
          <a (click) = "i === 0 ? loadMerchants({}) : getOffers('all')" class="flex align-center justify-center d-c-icon">
            <img [src]="tab?.logo_url" class="img-fluid">
          </a>
          <div class=" d-c-title flex justify-center text-center fnt-14 uppercase c3A4149 relative">
            <a [ngStyle]="{'color':(offerTypeToShow === tab.type) ?  GlobalConstants.data.colors.active_text_color : GlobalConstants.data.colors.main_text_color }"
              (click) = "i === 0 ? loadMerchants({}) : getOffers('all')" class="pad-top-10">{{tab.title}}</a>
            <div class="home-subcategory-dropdown pad-top-10" dropdown *ngIf="tab?.categories &&
              tab?.categories.length > 0">
              <div dropdownToggle class="down-icon flex  align-center">
                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L5 5L9 1" stroke="#333" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <div class="dropdown-menu subcat-drop dropdown-menu-shadow" *dropdownMenu>
                <div class="block loc-results">
                  <ng-container>
                    <div class="fnt-14"
                      *ngFor="let category of tab?.categories; let j = index">
                      <a class="option-box" (click) = "getOffers(category.attributes.code)"
                        >{{category.attributes.name}}</a>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="single-category pad-bot-15 pointer w100" *ngFor = "let tab of tabsToShow; let i = index"
          [ngStyle]="{'border-color':(offerBlockToShow == i) ?  GlobalConstants.data.colors.active_text_color : 'transparent' }"
          >
          <a routerLink="/{{tabsToShow[0].code}}/offers/{{i === 0 ? '' : 'all/all'}}" class="flex align-center justify-center d-c-icon">
            <img [src]="tab?.logo_url" class="img-fluid">
          </a>
          <div class=" d-c-title flex justify-center text-center fnt-14 uppercase c3A4149 relative">
            <a [ngStyle]="{'color':((offerBlockToShow == i)) ?  GlobalConstants.data.colors.active_text_color : GlobalConstants.data.colors.main_text_color }"
              routerLink="/{{tabsToShow[0].code}}/offers/{{i === 0 ? '' : 'all/all'}}" class="pad-top-10">{{tab.title}}</a>
            <div class="home-subcategory-dropdown pad-top-10" dropdown *ngIf="tab?.categories &&
              tab?.categories.length > 0">
              <div dropdownToggle class="down-icon flex  align-center">
                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L5 5L9 1" stroke="#333" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <div class="dropdown-menu subcat-drop dropdown-menu-shadow" *dropdownMenu>
                <div class="block loc-results">
                  <ng-container>
                    <div class="fnt-14"
                      *ngFor="let category of tab?.categories; let j = index">
                      <a class="option-box"
                        routerLink="/{{tabsToShow[0].code}}/offers/{{i === 0 ? '' : 'all/' + category.attributes.code}}">{{category.attributes.name}}</a>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </ng-container>
    </section>


  </section>
  <div class="container ">
    <section *ngIf="is_loading" class="pad-top-30">
      <app-card-loader [count] = "12" [perLine] = "3"></app-card-loader>
    </section>

    <section id = "offers" *ngIf="!is_loading">
      <div class="row">
        <ng-container class="" *ngFor="let merchant of merchants">
          <div class="col-md-4 d-single-off mar-top-30" *ngIf="merchant.attributes?.offers && merchant.attributes?.offers?.data?.length > 0">
            <app-offers-card [merchant]="merchant" [authenticated_user]="authenticated_user" [isMobile]="false"
              (claimOffer)="redeemOffer(merchant)"></app-offers-card>
          </div>
        </ng-container>
      </div>
      <div class="pagination-block relative" *ngIf="totalPages > 1">
        <div class="flex justify-center align-center">
          <div class="fir-lst fnt-12 disabled flex align-center pointer" (click)="pageClicked(1,offerTypeToShow)">FIRST
          </div>
          <div class="prev-nxt f500 flex justify-center align-center pointer"
            (click)="pageClicked(currentPage-1,offerTypeToShow)" *ngIf="currentPage > 1"><img
              src="./assets/img/icons/pagination-arrow.svg" class="rotate-180 prev-ic"> PREV</div>
          <div class="page-number" *ngIf="pageNumStart > 0">....</div>
          <div class="page-number pointer"
            *ngFor="let item of totalPageNumbers | slice:pageNumStart:pageNumEnd; let i = index;"
            [style.background-color]="item == currentPage - 1 ? GlobalConstants.data.colors.mainBtn_color : ''"
            [ngClass]="{'active' : item == currentPage - 1}" (click)="pageClicked(item+1,offerTypeToShow)">{{item+1}}
          </div>
          <div class="page-number" *ngIf="totalPages > pageNumEnd">....</div>
          <div class="prev-nxt f500 flex justify-center align-center pointer"
            (click)="pageClicked(currentPage+1,offerTypeToShow)" *ngIf="totalPages > currentPage">NEXT<img
              src="./assets/img/icons/pagination-arrow.svg" class="next-ic"></div>
          <div class="fir-lst fnt-12 flex align-center pointer" (click)="pageClicked(totalPages,offerTypeToShow)">LAST
          </div>
        </div>
      </div>
    </section>
    <div class="no-offers text-center fnt-20 f600 pad-top-50 pad-bot-50 mar-bot-45" *ngIf = "!is_loading && (!merchants || merchants.length === 0)">No offers available!</div>
  </div>
</section>
<!-- Mobile -->
<section class="mobile" *ngIf="isMobile">
  <div *ngIf="is_cd_loading" class="flex align-center justify-center loader-parent">
    <div class="page-loader"></div>
  </div>
  <div *ngIf="!is_cd_loading">
    <div>
      <div *ngIf="isIslamic && merchants">
        <div class="main-contain">
          <div class="flex container no-padding">
            <section class="col no-padding-mob">
              <section class="new-cat-offer-contain mar-top-20" >
                  <div class="section-title-sec flex space-between relative">
                    <div class="flex">
                      <div class="section-img"><img [src]="tabsToShow[0].logo_url" class="img-fluid"></div>
                      <div class="section-title pad-top-2 f600 c2C2A2A fnt-15"
                        [ngStyle]="{'color': GlobalConstants.data.colors.main_text_color}">{{tabsToShow[0].title}}</div>
                    </div>
                    <div class="new-see-all fnt-12 c0F7CED flex align-center pad-top-2 pointer"
                      *ngIf="total_entries > 2"><a
                        (click)="contentToShow = 'special-list'">See All
                        ({{total_entries}})</a></div>
                  </div>
                  <div class="custom-scroller extra-offer">
                    <div *ngFor="let merchant of merchants | slice:0:5" class="slide flex item">
                      <app-offers-card class="block w100" [merchant]="merchant" [authenticated_user]="authenticated_user" [isMobile]="true"
                        (claimOffer)="redeemOffer(merchant)">
                      </app-offers-card>
                    </div>
                  </div>
              </section>
            </section>
          </div>
        </div>
      </div>
      <div *ngIf="pageType === 'default' && offerCategories">
        <div class="main-contain">
          <div class="flex container no-padding">
            <section class="col no-padding-mob">
              <section class="new-cat-offer-contain mar-bot-25 mar-top-20" >
                <div *ngFor="let offerCategory of offerCategories; let i = index;">
                  <div class="section-title-sec flex space-between relative">
                    <div class="flex">
                      <div class="section-img"><img [src]="offerCategory?.attributes?.logo_url" class="img-fluid"></div>
                      <div class="section-title pad-top-2 f600 c2C2A2A fnt-15"
                        [ngStyle]="{'color': GlobalConstants.data.colors.main_text_color}">{{offerCategory.attributes.name}}</div>
                    </div>
                    <div class="new-see-all fnt-12 c0F7CED flex align-center pad-top-2"
                      *ngIf="offerCategory.attributes?.merchants_count > 2"><a
                        (click)="enableRouterReload(true)" [routerLink]="'/offer/offer-list/' + offerCategory.attributes.code">See All
                        ({{offerCategory?.attributes?.merchants_count}})</a></div>
                  </div>
                  <div class="custom-scroller theme-one-offer" *ngIf="offerCategory?.attributes?.merchants">
                    <div *ngFor="let merchant of offerCategory.attributes.merchants" class="slide flex item">
                      <app-offers-card class="block w100" [merchant]="merchant" [authenticated_user]="authenticated_user" [isMobile]="true"
                        (claimOffer)="redeemOffer(merchant)">
                      </app-offers-card>
                    </div>
                  </div>
                </div>
              </section>
            </section>
          </div>
        </div>
        <!-- End Template 1 -->
      </div>
      <section class="special-offers mar-bot-25 container pad-top-25" *ngIf="pageType === 'special-benefits' && merchants">
        <div class="flex wrap">
          <div class="flex item mar-bot-20"  *ngFor="let merchant of merchants">
            <app-offers-card class="block w100" [merchant]="merchant" [authenticated_user]="authenticated_user" [isMobile]="true"
              (claimOffer)="redeemOffer(merchant)">
            </app-offers-card>
          </div>
        </div>
      </section>
      <div class="no-offers text-center f600 pad-top-30" *ngIf = "(pageType === 'default' && (!offerCategories || offerCategories.length === 0)) || (pageType === 'special-benefits' && (!merchants || merchants.length === 0))">No offers available!</div>
    </div>
  </div>
</section>
</ng-container>

<ng-container *ngIf = "contentToShow === 'special-list'">
  <section class="breadcrumbs-parent">
    <div class="main-category flex align-center pad-right-5">
      <a class="back-icon" (click) = "contentToShow = 'home'">
      <svg xmlns="http://www.w3.org/2000/svg" fill = "#032082" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 386.242 386.242" style="enable-background:new 0 0 386.242 386.242;" xml:space="preserve">
        <g>
        	<path id="Arrow_Back" d="M374.212,182.3H39.432l100.152-99.767c4.704-4.704,4.704-12.319,0-17.011   c-4.704-4.704-12.319-4.704-17.011,0L3.474,184.61c-4.632,4.632-4.632,12.379,0,17.011l119.1,119.1   c4.704,4.704,12.319,4.704,17.011,0c4.704-4.704,4.704-12.319,0-17.011L39.432,206.36h334.779c6.641,0,12.03-5.39,12.03-12.03   S380.852,182.3,374.212,182.3z"/>
        </g>
        </svg>
      </a>
      <a  class="fnt-13 flex align-center justify-center f600 pad-top-1">{{tabsToShow[0].title}}</a>
    </div>
    <!-- <div class="breadcrumbs-sec flex pad-top-5 pad-bot-10 text-center custom-scroller">
      <a class="sub-cat fnt-11 flex align-center justify-center" [class.active] = "!selectedSubCategory" [routerLink] = "'/offer/offer-list/'+selectedCategory?.attributes?.code">ALL</a>
      <a [class.active] = "selectedSubCategory && selectedSubCategory.id == sub_category.id" [routerLink] = "'/offer/offer-list/'+selectedCategory?.attributes?.code+'/'+sub_category.code" class="sub-cat fnt-11 flex align-center justify-center" *ngFor="let sub_category of selectedCategory?.attributes?.sub_categories">
        {{sub_category?.name}}
      </a>
    </div> -->
  </section>
  <section class="special-offers mar-bot-25 container pad-top-25" *ngIf="merchants">
    <div class="flex wrap">
      <div class="flex item mar-bot-20"  *ngFor="let merchant of merchants">
        <app-offers-card class="block w100" [merchant]="merchant" [authenticated_user]="authenticated_user" [isMobile]="true"
          (claimOffer)="redeemOffer(merchant)">
        </app-offers-card>
      </div>
    </div>
  </section>
  <div class="no-offers text-center f600 pad-top-30" *ngIf = "((!merchants || merchants.length === 0) && !is_loading)">No offers available!</div>
</ng-container>

<!-- End Mobile -->
